<!--
 * @Author: linsc
 * @Date: 2023-04-04 10:47:45
 * @LastEditTime: 2023-04-13 16:01:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kcop-smcr\src\business\businessFile\GUOXIN\M0002\QS420_uploadImg.vue
-->
<template>
  <div class="QS420-upload-img-page">
      <img-collect-list nodeKey="appvTask" qrCodeType="3" imgType="uploadImg" ref="uploadImgView" :isShowNav="false" :bizData.sync = 'bizData' :historyData = "historyData" :oppBusiData = "oppBusiData" 
      :maxApptStatus="4" :isDisabled="isDisablePage"
      @after-load-img="getRiskResult"
      @on-next-click="next"></img-collect-list >
  </div>
</template>

<script>
import imgCollectList from "@/components/imageNode/imgCollectList.vue";


export default {
  data () {
    return {
            
    };
  },
  components: {
    imgCollectList
  },
  props: ["bizData", "historyData", "oppBusiData", "groupDatas", "busiCode","isDisablePage"],
  mounted () {
   
  },
  beforeDestroy (){
  },
  methods: {
    pageActivated (_this){
      _this.hideFooter(false);
    },
    validate (_this) {
      let that = _this.$refs.QS420_uploadImg;
      return that.$refs.uploadImgView.validate().then(flag=>{
        return flag;
      });
    },

    getRiskResult (_this){
      let suryRiskList = _.get(this,"historyData.BIZ_DATA.SURVEY_RESULT_LIST") || [];
      let hasSurey = suryRiskList.length;
      let item = _.find(_this.collectImgItems, v=>v.IMG_CLS=="Xb6");
      if(item){
        //有风险测评则Xb6风测问卷非必采
        item.COLLECT_MUST =  hasSurey ? "0" : "1";
      }
    },
    //下一步时，保存数据.
    beforeSave (_this, params, baseData) {

    },

    next () {
      //调用bizpage下一步按钮
      this.$emit("on-next-click");
    }
  }
    

};
</script>

<style lang="less" scoped>
.QS420-upload-img-page {
  width: 14.9rem;

}
</style>



// WEBPACK FOOTER //
// src/business/businessFile/QS420/QS420_uploadImg.vue